export default function Header({ view, setView }) {
  const tabs = [
    { id: "checkin", label: "today" },
    { id: "history", label: "history" },
    { id: "settings", label: "settings" },
  ];

  return (
    <div
      data-testid="app-header"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 max(16px, var(--safe-left)) 0 max(16px, var(--safe-right))",
        minHeight: 52,
        borderBottom: "1px solid rgba(29,158,117,0.1)",
        flexShrink: 0,
      }}
    >
      <div style={{
        fontFamily: "var(--serif)", fontSize: 18,
        color: "var(--cream)",
        display: "flex", alignItems: "center", gap: 8,
      }}>
        <div style={{
          width: 6, height: 6, borderRadius: "50%",
          background: "var(--teal)",
          animation: "pulseDot 3s infinite ease-in-out",
        }} />
        <span>hypha</span>
      </div>
      <div style={{ display: "flex", gap: 2 }}>
        {tabs.map((t) => (
          <button
            key={t.id}
            onClick={() => setView(t.id)}
            data-testid={`nav-btn-${t.id}`}
            style={{
              background: view === t.id ? "var(--teal-glow)" : "none",
              border: "none",
              /* 44px min tap target */
              padding: "0 12px",
              minHeight: 44,
              fontFamily: "var(--mono)",
              fontSize: 11,
              fontWeight: 300,
              letterSpacing: "0.08em",
              color: view === t.id ? "var(--cream)" : "var(--cream-faint)",
              cursor: "pointer",
              borderRadius: 4,
              transition: "color 0.2s, background 0.2s",
              textTransform: "lowercase",
              display: "flex",
              alignItems: "center",
            }}
          >
            {t.label}
          </button>
        ))}
      </div>
    </div>
  );
}
